import { Button } from "antd";
import React, { useState } from "react";
import { getParsicSMS } from "../../../api/api";
import { errorNotify, sucessNotify } from "../../../services/toast.notification";
import Spinner from "../../../components/_common/Spinner";

export interface InputProps {
    url: any
}

export default function ParsicSMSManagement({ url }: InputProps) {
    const handleClick = (id: number) => {
        _getParsicSMS(id);
    };
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState("");

    const _getParsicSMS = (requestId: number) => {
        setIsLoading(true);
        setStatus("");

        getParsicSMS(requestId, url)
            .then((result: any) => {
                if (result.data == "true") {
                    if (requestId == 1)
                        sucessNotify("سرویس با موفقیت روشن شد.");
                    else if (requestId == 3)
                        sucessNotify("سرویس با موفقیت خاموش شد.");
                }
                if (result.data == "false") {
                    if (requestId == 1)
                        errorNotify("خطا در روشن کردن سرویس");
                    else if (requestId == 2)
                        errorNotify("خطا در خاموش کردن سرویس");
                    else if (requestId == 3)
                        errorNotify("خطا در ریستارت کردن سرویس");
                }
                else {
                    if (requestId == 0)
                        setStatus("وضعیت: " + result.data);
                }

                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
                errorNotify("خطا")
            })
    }
    return (
        <>
            {isLoading === false && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ backgroundColor: 'blue', color: '#fff', marginLeft: '10px',borderRadius:'5px' }} onClick={() => handleClick(0)}>
                            دریافت وضعیت
                        </Button>
                        <Button style={{  backgroundColor: 'green', color: '#fff', marginLeft: '10px',borderRadius:'5px' }} onClick={() => handleClick(1)}>
                            روشن
                        </Button>
                        <Button style={{  backgroundColor: 'yellow', color: '#fff', marginLeft: '10px',borderRadius:'5px'}} onClick={() => handleClick(2)}>
                            ریستارت
                        </Button>
                        <Button style={{  backgroundColor: 'red', color: '#fff', marginLeft: '10px',borderRadius:'5px'}} onClick={() => handleClick(3)}>
                            خاموش
                        </Button>


                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        {status}
                    </div>
                </>
            )
            }
            {isLoading && (
                <Spinner />
            )
            }
        </>
    );
}
